// extracted by mini-css-extract-plugin
export var container = "_24-0";
export var disabled = "_24-4";
export var fullWidth = "_24-3";
export var lined = "_24-1";
export var selected = "_24-5";
export var tab = "_24-2";